<template>
<card-avatar ></card-avatar>
</template>

<script>
import CardAvatar from "@/components/card";
export default {
  name: "showApp",
  components: {CardAvatar},
}
</script>

<style scoped>

</style>